<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light header">
    <!-- <a class="navbar-brand" href="#">Navbar</a> -->
    <div class="logo">
      <img src="@/assets/logo.png" alt="" @click="logoLinkHome">
    </div>
    <div class="collapse navbar-collapse navCont" :class="{ show: isMobileMenuOpen }" id="navbarCollapse">
      <ul class="navbar-nav">
        <li class="nav-item" v-for="(item, index) in navList" :key="index" @click="navToLink(item, index)"">
          <router-link :to="item.path"
          :class="seachActive ? 'nav-item-link' : navActiveKey === index ? 'nav-item-link nav-item-link-active' : 'nav-item-link'">
            <div class="nav-item-link-text">
              {{ item.title }}
              <span :class="seachActive ? '' : navActiveKey === index ? 'navClickSpan' : ''"></span>
            </div>
          </router-link>
          
        </li>
      </ul>
    </div>
    <div class="locales">
      <!-- <el-select class="localesSelect" v-model="localesValue" placeholder="请选择">
        <el-option
          v-for="item in localesOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select> -->
      <div class="localesIcon">
        <div class="localesIconItem" @click="seachClick">
          <img src="@/assets/query.png" alt="" v-if="!isMobileFlag">
          <img src="@/assets/queryletter.png" alt="" v-else></img>
        </div>
        <el-dropdown class="localesIconItem" trigger="click" @command="handleDropdownCommand">
          <div class="el-dropdown-link">
            <img src="@/assets/locales.png" alt="" v-if="!isMobileFlag"></img>
            <img src="@/assets/localesletter.png" alt="" v-else></img>
          </div>
          <el-dropdown-menu slot="dropdown" class="el-dropdown-menu">
            <el-dropdown-item v-for="(item, index) in localesOptions" :key="index" :command="item.value"
              :class="{ 'is-active': selectedValue === item.value }">{{ item.label }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- </div> -->
      </div>
      <!-- 移动端导航按钮 -->
      <button class="navbar-toggler" type="button" @click="toggleMobileMenu" aria-controls="navbarCollapse"
        aria-expanded="true" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
  </nav>
</template>

<script>
import { bus } from '@/utils/bus'
import { getNavListing } from '@/api/komo';

export default {
  name: 'headerCont',
  data() {
    return {
      // navList: this.$t('nav'),
      navList: [],
      navActiveKey: 0,
      seachActive: false,
      localesOptions: this.$t('navLocales'),
      localesValue: 0,
      isMobileMenuOpen: false,
      selectedValue: 0,
      isMobileFlag: false,
    }
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    console.log('this.isMobile', this.isMobile)
    this.isMobileFlag = this.isMobile;
    // 在移动端点击导航项后关闭菜单
    if (window.innerWidth < 992) {
      this.isMobileMenuOpen = false;
    } else {
      this.isMobileMenuOpen = true;
    }
    // 初始化激活项
    // this.updateActiveByRoute();
    // this.$i18n.locale = 'zh-Hans';
    this.$i18n.locale = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'zh-Hans';
    localStorage.setItem('locale', localStorage.getItem('locale') ? localStorage.getItem('locale') : 'zh-Hans')
    
    bus.$emit('locale-change', this.$i18n.locale)

    // 初始化pageId
    localStorage.setItem('pageId', localStorage.getItem('pageId') ? localStorage.getItem('pageId') : 1);
    // localStorage.setItem('locale', 'zh-Hans');
    // 更新导航列表
    // this.navList = this.$t('nav');
  },
  watch: {
    // 路由变化时，更新选中导航
    $route() {
      this.updateActiveByRoute();
    },
    isMobile (val) {
      console.log('isMobile', val)
      this.isMobileFlag = val;
    }
  },
  created() {
    // 获取导航列表
    this.getNavListing();
    console.log('selectedValue',localStorage.getItem('selectedValue'));
    this.selectedValue = Number(localStorage.getItem('selectedValue') ? localStorage.getItem('selectedValue') :0) ;//初始值为英语 : 1
  },
  methods: {
    // 获取路由数据
    async getNavListing() {
      const res = await getNavListing();
      if (res.error === 0 && res.data) {
        this.navList = res.data?.list;
        // 导航数据加载完成后，更新激活状态
        this.$nextTick(() => {
          this.updateActiveByRoute();
        });
      }
    },
    // 导航项点击
    navToLink (item, index) {
      console.log(item,index)
      this.navActiveKey = index;
      this.seachActive = false;
      this.$emit('navToLink', item.title);
      localStorage.setItem('pageId', item.id);

      // 手机端点击路由关闭路由菜单
      this.isMobileMenuOpen = false;
    },
    handleDropdownCommand(command) {
      this.selectedValue = command;
      localStorage.setItem('selectedValue', command);
      // 根据command的值进行相应的操作
      // 例如，根据command的值切换语言
      switch (command) {
        case 0:
          this.$i18n.locale = 'zh-Hans';
          localStorage.setItem('locale', 'zh-Hans');
          break;
        case 1:
          this.$i18n.locale = 'en';
          localStorage.setItem('locale', 'en');
          break;
        case 2:
          this.$i18n.locale = 'Singapore';
          localStorage.setItem('locale', 'Singapore');
          break;
        case 3:
          this.$i18n.locale = 'Thailand';
          localStorage.setItem('locale', 'Thailand');
          break;
        case 4:
          this.$i18n.locale = 'Malaysia';
          localStorage.setItem('locale', 'Malaysia');
          break;
        case 5:
          this.$i18n.locale = 'Indonesia';
          localStorage.setItem('locale', 'Indonesia');
          break;
        case 6:
          this.$i18n.locale = 'Brazil';
          localStorage.setItem('locale', 'Brazil');
          break;
        default:
          this.$i18n.locale = 'en';
          localStorage.setItem('locale', 'en');
          break;
      }
      // 触发事件通知其他模块
      bus.$emit('locale-change', this.$i18n.locale)
      window.location.reload(true);  //语言切换之后刷新页面
      // 更新导航列表
      // this.navList = this.$t('nav');
    },
    logoLinkHome() {
      this.$router.push('/');
      this.navActiveKey = 0;
      this.seachActive = false;
      // 在移动端点击logo后关闭菜单
      if (window.innerWidth < 992) {
        this.isMobileMenuOpen = false;
      }
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    updateActiveByRoute() {
      // 确保导航数据已加载
      if (!this.navList || this.navList.length === 0) {
        return;
      }
      
      const path = this.$route && this.$route.path ? this.$route.path : '/';
      let idx = -1;
      
      // 特殊处理根路径
      if (path === '/') {
        idx = this.navList.findIndex(n => n.path === '/' || n.toLink === '/');
      } else {
        // 对于非根路径，查找匹配的导航项
        idx = this.navList.findIndex(n => {
          // 检查 path 字段（当前使用的字段）
          if (n.path && n.path !== '/' && path.startsWith(n.path)) {
            return true;
          }
          // 检查 toLink 字段（之前代码中使用的字段）
          if (n.toLink && n.toLink !== '/' && path.startsWith(n.toLink)) {
            return true;
          }
          return false;
        });
      }
      
      this.navActiveKey = idx >= 0 ? idx : 0;
      console.log('更新导航激活项:', this.navActiveKey, '当前路径:', path);
      localStorage.setItem('pageId', this.navList[this.navActiveKey].id);
    },
    seachClick() {
      this.$emit('navToLink', this.$t('seach.button'));
      this.seachActive = true;
      if (this.$route.path !== '/seach') {
        this.$router.push({ path: '/seach' });
      }
    }
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  height: 100%;
  background-color: #D5DCC8 !important;
  color: #1E1E1E;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  width: 9vw;
  height: 2vw;
  position: relative;
}

.logo img {
  width: 100%;
  height: 100%;
  cursor: pointer;
  object-fit: contain;
  position: absolute;
  top: 0;
}

.navCont {}

/* .localesSelect{
  width: 183px;
  background: #FFFFFF;
  border-radius: 8px;
  opacity: 0.4;
}
.localesSelect ::v-deep .el-input__inner{
  color: #1E1E1E;
  font-weight: bold;
}
.localesSelect ::v-deep .el-select__caret{
  color: #1E1E1E!important;
} */
.locales .navbar-toggler {
  margin-left: 20px;
  border: none;
  outline: none;
  width: 2.5vw;
  height: 2.5vw;
  position: relative;
  
}
.navbar-toggler-icon{
  width: 2.5vw;
  height: 2.5vw;
  position: absolute;
  top: 0;
}

.localesIcon {
  display: flex;
  gap: 30%;
}

.localesIconItem {
  width: 2.5vw;
  height: 2.5vw;
  cursor: pointer;
}

.localesIconItem img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.localesIconItem .el-dropdown-link {
  width: 100%;
  height: 100%;
}

.el-dropdown-menu {
  width: 8%;
}

.el-dropdown-menu__item.is-active {
  color: #409EFF;
  background-color: #ecf5ff;
}

/* .localesIconItem .el-dropdown{
  width: 100%;
  height:100%;
} */
.navbar {
  padding: 0 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.navbar-collapse {
  justify-content: center;
  height: 100%;
}

.navbar-nav {
  height: 100%;
}

.navbar-nav .nav-item {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.navbar-nav .nav-item .navClickSpan {
  width: 100%;
  height: 0.2vw;
  background: #64715D;
  display: block;
  position: absolute;
  bottom: 0;
}

.nav-item-link-text{
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.navbar-expand-lg .navbar-nav .nav-item .nav-item-link {
  text-decoration: none;
  color: #1E1E1E;
  font-size: 1.2vw;
  height: 100%;
  display: flex;
  align-items: center
}

.navbar-expand-lg .navbar-nav .nav-item .nav-item-link-active {
  font-weight: bold;
}

.navbar-expand-lg .navbar-nav {
  gap: 4vw;
}

@media (min-width: 1701px) {}

@media (max-width:1700px) {
  /* .navbar-expand-lg .navbar-nav {
    gap: 34px;
  } */
}

@media (max-width:1500px) {
  /* .navbar-expand-lg .navbar-nav {
    gap: 34px;
  } */
}

@media (max-width:1400px) {
  .localesSelect {
    width: 127px;
  }

  /* .navbar-expand-lg .navbar-nav {
    gap: 26px;
  } */
}

@media (max-width:1300px) {
  /* .navbar-expand-lg .navbar-nav {
    gap: 20px;
  } */
}

@media (max-width:1280px) {
  .localesSelect {
    width: 127px;
  }

  /* .navbar-expand-lg .navbar-nav {
    gap: 20px;
  }

  .navbar-expand-lg .navbar-nav .nav-item .nav-item-link {
    font-size: 20px;
  } */
}

@media (max-width:1220px) {
  .el-dropdown-menu {
    width: 30%;
  }

  .localesSelect {
    width: 127px;
  }

  /* .navbar-expand-lg .navbar-nav {
    gap: 20px;
  }

  .navbar-expand-lg .navbar-nav .nav-item .nav-item-link {
    font-size: 20px;
  } */
}

@media (max-width:1180px) {
  .localesSelect {
    width: 127px;
  }

  /* .navbar-expand-lg .navbar-nav .nav-item .nav-item-link {
    font-size: 18px;
  } */
}

@media (max-width:1100px) {
  .localesSelect {
    width: 110px;
  }

  /* .logo {
    width: 175px;
    height: 40px;
  } */

  /* .navbar-expand-lg .navbar-nav .nav-item .nav-item-link {
    font-size: 16px;
  } */
}

@media (max-width:1028px) {
  .localesSelect {
    width: 110px;
  }

  /* .logo {
    width: 100px;
    height: 25px;
  } */

  .localesIconItem {
    width: 30px;
    height: 30px;
  }
}

@media (max-width: 991px) {
  .logo {
    width: 23%;
    height: 41%;
  }
  .localesIconItem {
    width: 40%;
    height: 1%;
  }
  .locales .navbar-toggler{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 21%;
    height: 5vh;
  }
  .navbar-toggler-icon{
    width: 100%;
    height: 100%;
  }

  .navbar-expand-lg .navbar-nav .nav-item .nav-item-link {
    font-size: 1.2rem;
  }
  .navbar-collapse {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: auto;
    background-color: #D5DCC8;
    z-index: 1000;
    padding: 20px 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .navbar-nav {
    flex-direction: column;
    align-items: center;
  }
  .navbar-expand-lg .navbar-nav{
    gap: 0vw;
  }
  .navbar-nav .nav-item {
    height: 7vh;
    /* padding: 0 0 1vw; */
    width: 100%;
    justify-content: right;
    padding-right: 5%;
  }
  /* .navbar-nav .nav-item .navClickSpan {
    right: 5.5%;
  } */

  .locales {
    display: flex;
    align-items: center;
  }
}
</style>